var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolyUHkcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M202.719,380.581c-11.478,9.223-23.091,17.02-34.493,23.508c-2.964,6.014-5.71,12.054-8.125,18.062 c11.191-6.122,22.465-13.037,33.671-20.869c18.206-12.748,35.266-25.759,49.053-39.864c28.327-27.438,13.181-43.954,13.181-43.954 C244.694,338.995,228.157,360.166,202.719,380.581 M142.446,236.32C56.785,296.292-18.916,380.931,14.863,434.344 c12.079,17.243,37.776,22.166,69.805,16.319c3.826-8.015,8.348-16.123,13.505-24.292c-13.832-0.128-24.596-4.258-30.366-12.741 c-23.758-34.97,15.164-109.097,56.722-144.939c62.727-48.284,99.751-52.773,141.585-39.69l107.312-87.669 C318.13,143.254,222.847,185.267,142.446,236.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F1329",
    d: "M593.104,130.244c-78.854,2.757-214.732,62.648-329.367,135.462 C141.572,351.21,33.643,471.917,81.81,548.096c34.647,49.462,147.828,27.931,255.088-47.178 c25.98-18.173,50.308-36.726,69.964-56.831c40.397-39.117,18.78-62.67,18.78-62.67c-16.13,30.698-39.68,60.891-75.941,90.006 c-81.393,65.354-167.956,83.093-192.392,47.128c-33.889-49.886,21.599-155.576,80.866-206.673 c89.441-68.874,142.228-75.273,201.9-56.629L593.104,130.244z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M219.874,106.547c0-23.07,18.69-41.742,41.755-41.742c23.054,0,41.739,18.672,41.739,41.742 c0,23.021-18.685,41.72-41.739,41.72C238.564,148.268,219.874,129.569,219.874,106.547"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M385.507,80.658c0-32.87,26.656-59.523,59.528-59.523c32.881,0,59.525,26.654,59.525,59.523 c0,32.867-26.646,59.496-59.525,59.496C412.163,140.154,385.507,113.525,385.507,80.658"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyUHkcc);
export default __webpack_public_path__ + "static/media/PolyU_HKCC.ba89cae5e870bfa420f03758344f5e8c.svg";
export { ForwardRef as ReactComponent };